import gsap from 'gsap'
// import { Power2 } from 'gsap'
import koko from '../koko-framework/koko'
import { au } from '../koko-framework/shorthand'
import app from '../koko-framework/app'
// import * as PIXI from 'pixi.js'
import { setupClicker } from '../controller/ButtonController'

export class PPIntroView extends koko.view {
    currentGameView = null;

    textScrollStart = 0;
    textScrollMin = 0;
    textScrollDist = 0;
    scrollerStart = 0;
    scrollerMax = 0;
    draggingText = false;
    draggingScroller = false;

    /* constructor() {
        super();
    } */

    buildView() {
        var vp = app.viewPort;

        this.children = koko.display.buildLayout([
            { type: 'shape', name: 'bg', x: -280, y: 0, width: 1326, height: 1355, fill: 0, alpha: 0.6 },

            { type: 'sprite', id: 'carrier_big', name: 'bg2', x: vp.centerX, y: 678, width: 642, height: 1066, anchorX: 0.5, anchorY: 0.5 },
            { type: 'sprite', id: 'close_btn', name: 'close_btn', x: 620, y: vp.centerY - 450, width: 75, height: 63, anchorX: 0.5, anchorY: 0.5 },
            { type: 'sprite', id: 'pigpen_title', name: 'title', x: vp.centerX, y: vp.centerY - 400, width: 120, height: 62, anchorX: 0.5, anchorY: 0.5 },

            { type: 'container', name: 'scrollContent', x: vp.centerX, y: 330 },
            { type: 'bmptext', parent: 'scrollContent', text: 'Introduction:', font: 'typrighter_small', size: 30, tint: 0xDB001D, name: 'text', align: 'left', x: -265, y: 0, anchorX: 0, anchorY: 0 },
            { type: 'bmptext', parent: 'scrollContent', text: 'Pigpen ciphers are an example of a "simple\nsubstitution cipher". Each letter of the\nplaintext (the original message) is replaced\nwith another letter, number, picture or\nsymbol to form the ciphertext (the coded\nmessage).\n\nPigpen ciphers use grids like the ones below\nas their keys for encoding and decoding. Can\nyou work out how the key relates to the\nmysterious symbols in the ciphertext?', font: 'typrighter_small', size: 30, tint: 0, name: 'text', align: 'left', x: -265, y: 60, anchorX: 0, anchorY: 0 },
            { type: 'sprite', parent: 'scrollContent', id: 'pigpen_intro_image', name: 'tutimg1', x: 0, y: 380, width: 590, height: 401, anchorX: 0.5, anchorY: 0 },
            // { type: 'sprite', parent: 'scrollContent', id: 'caesar_hint_graphic', name: 'tutimg2', x: 0, y: 730, width: 590, height: 85, anchorX: 0.5, anchorY: 0 },
            // { type: 'bmptext', parent: 'scrollContent', text: 'This is just one way we could encode the\nletters. Perhaps you could come up with your\nown Pigpen cipher, using your own diagram\nas the secret key?\n\nPigpen ciphers have been widely used\nthroughout history to hide the meaning of\nnotes in diaries or other documents. They are\nquite easy to use, because they don’t need any\nspecialist equipment to code or decode. The\nFreemasons (a fraternal organisation) are\nknown to have used this cipher extensively,\nso it is often referred to the Masonic or\nFreemason\'s cipher.\n\nEnglish actress Diana Dors famously used a\ncoded message, which used Pigpen along with\nother ciphers, to hide the location of\nmillions of pounds she had concealed.\nAlthough the message was eventually\ndeciphered by a group of cryptologists, the\n(alleged) hidden fortune has never been\nfound.\n\nAnother legendary story of hidden treasure\nis of a pirate named Olivier Levasseur, who is\nthought to have buried gold, silver and gems,\nand to have left a coded message (using\nciphers including Pigpen) with instructions\nto find his loot. His treasure is still being\nsought out today.', font: 'typrighter_small', size: 30, tint: 0, name: 'text', align: 'left', x: -265, y: 765, anchorX: 0, anchorY: 0 },
            { type: 'sprite', id: 'continue_btn', name: 'continue_btn', x: vp.centerX, y: 1060, width: 434, height: 105, anchorX: 0.5, anchorY: 0 },

            { type: 'shape', name: 'scrollMask', fill: 0, x: vp.centerX - 295, y: 328, width: 295 * 2, height: 710 },

            { name: 'scroller', id: 'scroller', type: 'sprite', width: 8, height: 98, x: vp.centerX + 295, y: 330, anchorX: 0.5, anchorY: 0 },
            /*
            { type: 'sprite', id: 'wronganswer_carrier', name: 'bg2', x: vp.centerX, y: 400, width: 642, height: 333, anchorX: 0.5, anchorY: 0.5},
            { type: 'sprite', id: 'wronganswer_title', name: 'title', x: vp.centerX, y: 343, width: 98, height: 62, anchorX: 0.5, anchorY: 0.5},
            { type: 'bmptext', text: 'That answer wasn\'t quite right,\nhave another go!', font: 'typrighter_small', size: 30, tint: 0, name: 'text', align:'center', x: vp.centerX, y: 408, anchorX: 0.5, anchorY: 0},
            */
        ], this.container);

        this.resize();

        /*
        let event = koko.client.system.isMobile ? 'touchstart' : 'mousedown';
        this.children.close_btn.interactive = true;
        this.children.close_btn.on(event, this.closePop);

        this.children.continue_btn.interactive = true;
        this.children.continue_btn.on(event, this.gotoGame);
        */
        this.children.scrollContent.mask = this.children.scrollMask;

        this.draggingText = false;
        this.draggingScroller = false;
    }

    resize() {
        /*
        var vp = app.viewPort;
        let bg = this.children.bg;
        bg.width = vp.width + Math.abs(vp.x) * 4;
        bg.height = vp.height + Math.abs(vp.y) * 4;
        bg.x = vp.centerX - bg.width / 2;
        bg.y = vp.centerY - bg.height / 2;
        */
    }

    initInteraction = () => {
        setupClicker(this.children.close_btn, this.closePop);
        setupClicker(this.children.continue_btn, this.gotoGame);

        this.textScrollStart = this.children.scrollContent.y;
        let scrollDist = (this.children.scrollContent.height - this.children.scrollMask.height) + 20;
        if (scrollDist < 0) {
            scrollDist = 0;
            this.children.scroller.visible = false;
            this.children.scroller.interactive = false;
        }
        this.textScrollDist = scrollDist;
        this.textScrollMin = this.textScrollStart - scrollDist;

        this.scrollerStart = this.children.scroller.y;
        let scrollerTopBuffer = this.children.scroller.y - this.children.scrollMask.y;
        let scrollArea = this.children.scrollMask.height - scrollerTopBuffer * 2;
        let scrollerHeight = 200 * this.children.scrollMask.height / this.children.scrollContent.height;
        if (scrollerHeight < 20) {
            scrollerHeight = 20;
        }
        this.children.scroller.height = scrollerHeight;
        let scrollerMovement = scrollArea - this.children.scroller.height;
        this.scrollerMax = /*this.scrollerStart + */scrollerMovement;

        this.container.interactive = true;
        this.container.on('mousemove', this.dragSlider);
        this.container.on('pointermove', this.dragSlider);
        this.container.on('touchmove', this.dragSlider);
        this.container.on('mouseup', this.stopDraggingSlider);
        this.container.on('pointerup', this.stopDraggingSlider);
        this.container.on('touchend', this.stopDraggingSlider);

        document.onmouseleave = this.stopDraggingSlider;
        document.onpointerleave = this.stopDraggingSlider;
        document.onmouseup = this.stopDraggingSlider;
        document.onpointerup = this.stopDraggingSlider;

        if (this.children.scroller.visible) {
            this.children.scrollMask.on('mousedown', this.startDraggingText);
            this.children.scrollMask.on('pointerdown', this.startDraggingText);
            this.children.scrollMask.on('touchstart', this.startDraggingText);
            this.children.scrollMask.interactive = true;
        }

        if (this.children.scroller.visible) {
            this.children.scroller.on('mousedown', this.startDraggingScroller);
            this.children.scroller.on('pointerdown', this.startDraggingScroller);
            this.children.scroller.on('touchstart', this.startDraggingScroller);
            this.children.scroller.interactive = true;
        }
    }

    transitionIn = (currentGameView = null) => {
        this.currentGameView = currentGameView;
        this.buildView();
        this.show();
        this.enable();
        this.container.alpha = 0;
        gsap.to(this.container, { alpha: 1, duration: 0.35, onComplete: this.initInteraction });

        // setTimeout(this.transitionOut, 2000);

        au.playRandom('pop', 1, 10);
    }

    transitionOut = () => {
        if (this.currentGameView && this.currentGameView.popClosed) {
            this.currentGameView.popClosed();
        }

        gsap.to(this.container, { alpha: 0, onComplete: this.transitionOutDone, duration: 0.35 });
    }

    transitionOutDone = () => {
        // gsap.killAll();
        // this.destroyGameObjects();  
        // game.destroy();
        // game = null;
        this.destroyView();
        this.hide();

        /*
        PIXI.Ticker.shared.stop();
        app.renderer.renderer.plugins.interaction.destroy();

        app.paused = true;
        app.renderer.destroy();
        PIXI.utils.destroyTextureCache();
        */
    }

    closePop = (e) => {
        au.play('button', 1, false);
        if (this.currentGameView && this.currentGameView.popClosed) {
            this.currentGameView.popClosed();
        }
        this.transitionOut();
    }

    gotoGame = (e) => {
        this.closePop();
        if (this.currentGameView) {
            this.currentGameView.transitionOut();
        }
    }

    startDraggingText = (e) => {
        // console.log('start dragging text');
        this.draggingText = true;
        this.startMouseY = this.container.toLocal(e.data.global).y;
        this.startTextY = this.children.scrollContent.y;
        // this.closeKeyboard();
    }

    startDraggingScroller = (e) => {
        this.draggingScroller = true;
        this.startMouseY = this.container.toLocal(e.data.global).y;
        this.startScrollerY = this.children.scroller.y;
        // this.closeKeyboard();
    }

    dragSlider = (e) => {
        if (this.draggingScroller) {
            let thisPoint = this.container.toLocal(e.data.global);
            let moveDistance = thisPoint.y - this.startMouseY;
            let newY = this.startScrollerY + moveDistance;
            if (newY > this.scrollerStart + this.scrollerMax) {
                newY = this.scrollerStart + this.scrollerMax;
            }
            if (newY < this.scrollerStart) {
                newY = this.scrollerStart;
            }
            this.children.scroller.y = newY;
            let movePerc = Math.abs(this.children.scroller.y - this.scrollerStart) / this.scrollerMax;
            this.children.scrollContent.y = this.textScrollStart - movePerc * this.textScrollDist;
        } else
            if (this.draggingText) {
                let thisPoint = this.container.toLocal(e.data.global);
                let moveDistance = thisPoint.y - this.startMouseY;
                let newY = this.startTextY + moveDistance;
                if (newY > this.textScrollStart) {
                    newY = this.textScrollStart;
                }
                if (newY < this.textScrollMin) {
                    newY = this.textScrollMin;
                }
                this.children.scrollContent.y = newY;
                let movePerc = Math.abs(this.children.scrollContent.y - this.textScrollStart) / Math.abs(this.textScrollStart - this.textScrollMin);
                this.children.scroller.y = this.scrollerStart + movePerc * this.scrollerMax;
            }
    }

    stopDraggingSlider = (e) => {
        this.draggingText = false;
        this.draggingScroller = false;
    }
}